'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkflowSlider = function WorkflowSlider(_ref) {
    var component = _ref.component,
        doSetReturn = _ref.doSetReturn,
        returnProp = _ref.return;

    var prevReturnPropRef = (0, _react.useRef)();

    (0, _react.useEffect)(function () {
        prevReturnPropRef.current = returnProp;
    });

    (0, _react.useEffect)(function () {
        setTimeout(function () {
            var min = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Min') || 0;
            var defaultVal = (0, _metrixCommon.getElementValueByCode)(returnProp && returnProp.elements, 'Value') || min;

            var curentValue = returnProp && (0, _metrixCommon.getElementValueByCode)(returnProp && returnProp.elements, 'Value');
            var prevValue = prevReturnPropRef.current && (0, _metrixCommon.getElementValueByCode)(prevReturnPropRef.current.elements, 'Value');

            if (!returnProp && prevValue === curentValue) {
                handleChange(defaultVal);
            }
        }, 50);
    }, [returnProp && (0, _metrixCommon.getElementValueByCode)(returnProp && returnProp.elements, 'Value')]);

    var handleChange = function handleChange(value) {
        doSetReturn({ componentCode: component.code, code: 'Value', value: value });
    };

    var type = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Type');
    var unit = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Unit') || '';
    var unitAlignment = (0, _metrixCommon.getElementValueByCode)(component.elements, 'UnitAlignment') || 'right';
    var header = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Header') || false;
    var min = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Min') || 0;
    var max = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Max');
    var maxPathValue = returnProp && (0, _metrixCommon.getElementValueByCode)(returnProp.elements, 'MaxValue');
    var minPathValue = returnProp && (0, _metrixCommon.getElementValueByCode)(returnProp.elements, 'MinValue');

    var label = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Label');
    var labelL = (0, _metrixCommon.getElementValueByCode)(component.elements, 'LeftLabel');
    var labelR = (0, _metrixCommon.getElementValueByCode)(component.elements, 'RightLabel');
    var increment = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Increment') || 1;
    var valSeparator = (0, _metrixCommon.getElementValueByCode)(component.elements, 'ValueSeparator') || false;

    var value = returnProp && (0, _metrixCommon.getElementValueByCode)(returnProp.elements, 'Value') || min;

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        label && _react2.default.createElement(_metrixCommon.Label, { text: label, textAlign: _metrixCommon.Alignments.left }),
        _react2.default.createElement(_metrixCommon.Slider, { value: value,
            type: type,
            unit: unit,
            top: label ? '1rem' : '0',
            unitAlignment: unitAlignment,
            header: header === 'yes',
            min: minPathValue ? minPathValue : min,
            max: maxPathValue ? maxPathValue : max,
            leftLabel: labelL,
            rightLabel: labelR,
            increment: increment,
            valueSeparator: valSeparator === 'yes',
            changeEvent: handleChange,
            fullSize: true
        })
    );
};

WorkflowSlider.propTypes = {
    component: _propTypes2.default.object.isRequired,
    doSetReturn: _propTypes2.default.func.isRequired,
    return: _propTypes2.default.object
};

exports.default = WorkflowSlider;